import defaultTheme from 'tailwindcss/defaultTheme'

const defaultBreakpoints = defaultTheme.screens

export const customBreakpoints = {
  xs: '340px',
  // MUI breakpoints
  msm: '600px', // MUI sm
  mmd: '900px', // MUI md
  mlg: '1024px', // MUI lg - use 1024 to optimize exp for iPad, etc. using desktop layout
  xlg: '1400px',
  mxl: '1536px', // MUI xl
}

export const breakpoints = {
  ...defaultBreakpoints,
  ...customBreakpoints,
}

export type Breakpoint = keyof typeof breakpoints
